import { get, mapValues, toNumber } from 'lodash';
import { getDetor } from '../../../api/api';
import { createModifierPath } from '../../../lib/helper';

export const filterSelectedModfiers = (
  modifierList,
  selectedList,
  checkedItemList,
  apiDefaultParams,
  type,
  onDetourUpdate = false,
  loadingMore = false
) => {
  return new Promise((resolve, reject) => {
    modifierList.map((data, key) => {
      if (data.option && data.option.length > 0) {
        modifierList[key]['root'] = true;
        modifierList[key]['selected'] = true;
        filterSelectedModfiers(
          data.option,
          selectedList,
          checkedItemList,
          apiDefaultParams,
          data.type,
          onDetourUpdate,
          loadingMore
        ).then(list => {
          modifierList[key]['option'] = list;
        });
      } else {
        if (checkedItemList.includes(data.modifierPath)) {
          modifierList[key]['selected'] = true;
          modifierList[key]['isChecked'] = true;
          modifierList[key]['wasChecked'] = false;
          modifierList[key]['addToBag'] = false;

          selectedList.push({
            cost: data.cost,
            nutrition: data.nutrition,
          });

          if (data.doption) {
            filterSelectedModfiers(
              data.doption,
              selectedList,
              checkedItemList,
              apiDefaultParams,
              data.type,
              onDetourUpdate,
              loadingMore
            ).then(list => {
              modifierList[key]['doption'] = list;
            });
          } else if (
            (data.type === 'choice' ||
              data.type === 'checklist' ||
              !data.type) &&
            get(data, 'detour', '') &&
            apiDefaultParams &&
            type === 'choice'
          ) {
            let apiParameters = JSON.parse(JSON.stringify(apiDefaultParams));
            apiParameters['detour_id'] = data.detour;
            if (loadingMore) {
              loadingMore();
            }
            getDetor(apiParameters).then(function(response) {
              data.doption = createModifierPath(
                get(response, 'data.DataResponse', []),
                data.modifierPath
              );
              if (data.doption) {
                filterSelectedModfiers(
                  data.doption,
                  selectedList,
                  checkedItemList,
                  apiDefaultParams,
                  data.type,
                  onDetourUpdate,
                  loadingMore
                ).then(list => {
                  modifierList[key]['doption'] = list;
                  if (onDetourUpdate) {
                    onDetourUpdate(checkedItemList);
                  }
                });
              } else if (onDetourUpdate) {
                onDetourUpdate(checkedItemList);
              }
            });
          }
        } else {
          if (
            modifierList[key]['isChecked'] === true &&
            modifierList[key]['addToBag'] === true
          ) {
            modifierList[key]['wasChecked'] = true;
          }
          modifierList[key]['addToBag'] = false;
          modifierList[key]['isChecked'] = false;
          modifierList[key]['selected'] = false;
        }
      }
      return modifierList;
    });
    resolve(modifierList);
  });
};

export const checkAllModifiersSelected = (modifierList, statusList, type) => {
  modifierList.map((data, key) => {
    type = type || data.type;
    if (data.option && data.option.length > 0) {
      checkAllModifiersSelected(data.option, statusList, data.type);
    } else {
      const itemGroupKey = data.group;

      if (!statusList[itemGroupKey] && type === 'choice') {
        statusList[itemGroupKey] = false;
      }

      if (
        statusList[itemGroupKey] === false &&
        type === 'choice' &&
        data.isChecked
      ) {
        statusList[itemGroupKey] = true;
        modifierList[key]['addToBag'] = true;
        if (data.doption && data.doption.length > 0) {
          checkAllModifiersSelected(
            data.doption,
            statusList,
            data.type || type
          );
        }
      } else if (type === 'checklist') {
        if (data.isChecked) {
          modifierList[key]['addToBag'] = true;
          if (data.doption && data.doption.length > 0) {
            checkAllModifiersSelected(
              data.doption,
              statusList,
              data.type || type
            );
          }
        }
      }
    }
  });

  return modifierList;
};

export const validateItem = modifierList => {
  let statusList = {};
  let updatedModifierlist = checkAllModifiersSelected(modifierList, statusList);
  var validatedResult = {
    status: true,
    modifierList: updatedModifierlist,
    errorCount: Object.keys(statusList).length,
    list: statusList,
  };
  mapValues(statusList, function(value) {
    if (value === false) {
      validatedResult['status'] = false;
    }
  });
  return validatedResult;
};

export const enforceAllForceModifierCount = (
  modifierList,
  typeOption,
  options
) => {
  return modifierList.every(list => {
    const modifierStatus = enforceForceModifierCount(
      typeOption(list),
      options(list)
    );
    return modifierStatus.selected === modifierStatus.count;
  });
};
export const enforceForceModifierCount = (typeOption, listOptions) => {
  const count = toNumber(typeOption);
  if (isNaN(count) || count === 0) {
    return { selected: -1, count: -1 };
  }
  const selectedCount = listOptions.filter(v => v.selected).length;
  return {
    selected: selectedCount,
    count,
  };
};

export const getEnforcedModifierCount = typeOption => {
  typeOption = toNumber(typeOption);
  return isNaN(typeOption) ? 0 : typeOption;
};

export const filterItemModifier = options => {
  if (!options.i) {
    return { i: {}, r: {} };
  }
  options.i.map((data, key) => {
    if (data.isChecked || data.wasChecked) {
      const groupKey = data.group;
      if (!options.r[groupKey]) {
        options.r[groupKey] = {
          selectedModifiers: [],
          whereSelectedModifiers: [],
        };
      }

      let ingredients = {
        title: data.title,
        cost: data.cost,
        availability: data.availability,
      };

      if (data.isChecked) {
        options.r[groupKey]['selectedModifiers'].push(ingredients);
      } else if (data.wasChecked) {
        options.r[groupKey]['whereSelectedModifiers'].push(ingredients);
      }
    }
    if (data.option && data.option.length > 0 && data.selected) {
      filterItemModifier({ i: data.option, r: options.r });
    }
    if (data.doption && data.doption.length > 0) {
      filterItemModifier({ i: data.doption, r: options.r });
    }
  });

  return options;
};

export const handleSpecialInstruction = (e, allowedCharacter) => {
  allowedCharacter = allowedCharacter || 300;
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9\t\s\n\'\,\.]/g, '');
  if (e.target.value.toString().length >= allowedCharacter) {
    e.target.value = e.target.value.slice(0, allowedCharacter);
  }
};

export const restrictSubmit = (e, keyCode) => {
  let eventCode = e.keyCode ? e.keyCode : e.which;
  let restrictOnCode = keyCode || 13;
  if (eventCode === restrictOnCode) {
    e.preventDefault();
  }
};



// WEBPACK FOOTER //
// ./src/views/dashboard/actions/cartActions.js